import { Localization } from "../../../../../../OW.Remoting/Remoting/Localization";
import { Checkbox } from "../../../../../UI.BaseControls/Checkbox";
import { Control } from "../../../../../UI.BaseControls/Control";
import { EditableControl } from "../../../../../UI.BaseControls/EditableControl";
import { createElement, registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IOperation, IReplaceFilterItem, IReplaceItemData } from "../FilterInterfaces";
import { dateTimeFilterRecreateFunction } from "../FilterShared";
import { IStructureExtension } from "../IStructureExtension";
import { IWithInclude } from "../IWithInclude";
import { FilterDateEdit } from "./FilterDateEdit";

export class DateWithInclude extends EditableControl implements IStructureExtension, IWithInclude, IReplaceFilterItem {
    private _include: Checkbox;
    private _desc: HTMLElement;
    private _subOperationID: string = null;
    private _dateEdit: FilterDateEdit;

    public get subOperationID(): string {
        return this._subOperationID;
    }

    public set subOperationID(value: string) {
        if ((value == "day") && (value != this._subOperationID)) {
            this._subOperationID = value;
            this.setDefaultTime();
        } else {
            this._subOperationID = value;
        }
    }

    public get include(): boolean {
        return this._include.visible && this._include.checked;
    }

    public set include(v: boolean) {
        this._include.checked = v;
        this.setDefaultTime();
        this.callEvent("change");
    }

    public get includeVisible(): boolean {
        return this._desc.parentElement.style.display != "none";
    }

    public set includeVisible(v: boolean) {
        this._desc.parentElement.style.display = v ? "" : "none";
    }

    public override get value(): any {
        return this._dateEdit.value;
    }

    public override set value(value: any) {
        this._dateEdit.value = value;
    }

    protected override _constructor(): void {
        super._constructor();

        this._createElement();
        this._setListener();
    }

    protected override connectedCallback(): void {
        super.connectedCallback();

        Control.unregisterEventListener(this._eventGroup, this._innerElement, "focusout");
        Control.registerEventListener(this._eventGroup, this._innerElement, "focusout", () => {
            if (!this.isValid) // stav nevalidnosti nektere komponenty se nebude prepisovat stavem, ze jedno pole neni vyplneno
                return;
        });
    }

    public recreateFilter(operation: IOperation): IReplaceItemData[] {
        return dateTimeFilterRecreateFunction(this._dateEdit.userValue, operation);
    }

    private _createElement(): void {
        this.innerHTML = "";

        this._innerElement = document.createElement("div");
        this.appendChild(this._innerElement);
        this._innerElement.classList.add("DateWithIncludeParent");

        this._dateEdit = new FilterDateEdit();

        const cont = createElement({ classes: "check-cont" });
        this._include = new Checkbox();
        this._include.required = true;
        this._desc = createElement({ type: "span", classes: "description" });

        cont.style.display = "none";

        this._include.standardAction = true;

        Localization.addLocData(this._desc, "GUI-603192"); //Včetně

        cont.appendChild(this._include);
        cont.appendChild(this._desc);

        this.classList.add("DateEditWithInclude");

        this._innerElement.appendChild(this._dateEdit);
        this._innerElement.appendChild(cont);
    }

    private _setListener(): void {
        this._include.addEventListener("change", () => this.include = this._include.value);
        this.afterAttach(() => {
            this._dateEdit.registerEventListener("change", (_e) => {
                this.callEvent("change");
            });

            this._dateEdit.registerEventListener("keyup", (e) => {
                this.callEvent("keyup", { original: e });
            });
        });
    }

    private setDefaultTime(): void {
        if (this._dateEdit.controlValue) {
            const date = this._dateEdit.controlValue;
            if (this.include) {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
                date.setMilliseconds(0);
            } else {
                date.setHours(23);
                date.setMinutes(59);
                date.setSeconds(59);
                date.setMilliseconds(59);
            }
            this._dateEdit.controlValue = date;
        }
    }

    //#region Dispose
    public override dispose(): void {
        //this._include.removeEventListener('change', this._includeChangeListener); //TODO: IFRAME - vola se už při skrytí popup menu a nenaváže se to znovu při zobrazení
        //this._dateEdit.removeEventListener('change', this._dateEditChangeListener); //TODO: IFRAME - vola se už při skrytí popup menu a nenaváže se to znovu při zobrazení
        //this._dateEdit.removeEventListener('keyup', this._dateEditKeyUpListener); //TODO: IFRAME - vola se už při skrytí popup menu a nenaváže se to znovu při zobrazení
        super.dispose();
    }

    //#endregion Dispose
}

registerCustomElement("tsc-DateWithInclude", DateWithInclude);
